import { useMemo, useState } from 'react'

// This is a temporary replacement for the old useObject that was defined on `Model`.
// This function performs the same purpose, which is to force React to rerender
// whenever any property on the passed-in object is modified.
//
// The passed-in object must implement a clone method so that we can regenerate the
// object whenever anything changes.
//
// We hope to eventually remove this hook entirely in favor of immutable state updates.
export const useRerenderOnMutation_deprecated = <T extends { clone: () => T }>(object: T): T => {
    const [updatedObject, setUpdatedObject] = useState(object)

    return useMemo(() => {
        return new Proxy(updatedObject, {
            set(target, key, value) {
                ;(target as any)[key] = value
                setUpdatedObject(updatedObject.clone())
                return true
            },
        })
    }, [updatedObject])
}
